import { Client } from '../../../features/bot/modules/bot-crm/store';
import { ChatMessage, ChatMessageBody } from './chat-state.model';

// ------------------- Client -----------------------
export class SetClient {
  static readonly type = '[Chat] Set Client';
  constructor(public client: Client) {}
}

export class ChangeDialogMode {
  static readonly type = '[Chat] Change Dialog Mode';
}

// -------------------- Chat ------------------------

export class GetMessages {
  static readonly type = '[Chat] Get Messages';
}

export class SendMessage {
  static readonly type = '[Chat] Send Message';
  constructor(public message: ChatMessageBody) {}
}

export class SendFile {
  static readonly type = '[Chat] Send File';
  constructor(
    public file: File,
    public type: 'image' | 'file' | 'audio' | 'video'
  ) {}
}

export class RunScenario {
  static readonly type = '[Chat] Run Scenario';
  constructor(public scenarioId: string) {}
}

export class PushNewMessage {
  static readonly type = '[Chat] Push New Message';
  constructor(public message: ChatMessage) {}
}

export class SwitchInfoMode {
  static readonly type = '[Chat] Switch Info Mode';
}

export class GetSuggestions {
  static readonly type = '[Chat] Get Suggestions';
  constructor(public keyword: string) {}
}
